/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Video_UploadInputs */



/**
* | output |
* | --- |
* | "Video Upload" |
*
* @param {Embed_Captions_Video_UploadInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_video_upload = /** @type {((inputs?: Embed_Captions_Video_UploadInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Video_UploadInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Televersement video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Video-Upload")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subir vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频上传")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオアップロード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो अपलोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Upload de vídeo")
	return /** @type {LocalizedString} */ ("Video Upload")
});